import {Cart} from "./cart";
import {CartPriceComponents} from "./cartpricecomponents";

export class CartItem {
    /** @type {Cart} */
    cart = null;

    constructor(item, cart) {
        for(let property in item) {
            if(property == 'amount' || property == 'checking_id') {
                this[property] = ko.observable(item[property]);
            } else {
                this[property] = item[property];
            }
        }

        this.amount.subscribe(() => $(window).trigger('cart-item-changed'));
        this.checking_id.subscribe(() => $(window).trigger('cart-item-changed'));

        // Additional properties
        this.cart = cart;
        this.priceComponents = ko.computed(() => {
            const components = new CartPriceComponents();
            components.price = parseFloat(this.sum);

            if(this.cart.checkingTypes[this.checking_id()] !== undefined) {
                components.checking = parseFloat(this.cart.checkingTypes[this.checking_id()].price);
            }

            return components;
        });
        this.canAdd = ko.computed(
            () => this.amount() < this.cart.maxQuantity
                && this.cart.canAdd(this.priceComponents().price, false)
        );
        this.canSubtract = ko.computed(
            () => this.amount() > 1
        );
    }

    serializeArray() {
        const result = {};
        const notSerializableProperties = ['cart', 'priceComponents'];

        for(let property in this) {
            if(notSerializableProperties.indexOf(property) !== -1) {
                continue;
            }

            result[property] = ko.unwrap(this[property]);
            if(result[property] === undefined) {
                result[property] = null;
            }
        }

        return result;
    }

    navigateToProduct(item, e) {
        const $target = $(e.target);
        if(!$target.closest('.quantity').length && !$target.closest('.select-wrapper').length) {
            window.open(this.order_id);
        }
    }
}


// WEBPACK FOOTER //
// ./modules/packages/common/model/cartitem.js